import React from 'react'
import './StepIndicator.css'

interface StepIndicatorProps {
    step: number
    maximumSteps: number
    style?: any
}

export default class StepIndicator extends React.Component<StepIndicatorProps, {}> {

    renderPoints() {
        const points: any = []
        for (var i = 0; i < this.props.maximumSteps; ++i) {
            points.push(
                <div className={"step-indicator-point " + (this.props.step === i ? 'step-indicator-active' : 'step-indicator-inactive')} key={i} />
            )
        }

        return points
    }

    render() {
        return (
            <div className="step-indicator-container" style={this.props.style}>
                {this.renderPoints()}
            </div>
        )
    }
}
